import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Animation from '../../../components/LoadingAnimation';
import Title from '../../../components/Title';
import {
  getShopSkin,
  setShopScript,
  deleteShopScript,
  getContentsList,
  getPCPublishedContentList,
  getMobilePublishedContentList,
  setMobileShopScript,
  getMobileShopSkin,
  deleteMobileShopScript,
  getMobileShopEnabled,
  getUserDetail,
  checkPlugins,
} from '../../../modules/NetworkFunction';
import AuthContext from '../../../contexts/AuthContext';

import { ReactComponent as IcInfo } from '../../../icons/ic-info.svg';
import icPc from '../../../icons/ic-pc.svg';
import icMobile from '../../../icons/ic-mobile.svg';
import { ReactComponent as NextIcon } from '../../../icons/ic-next.svg';
import useCafe24Auth from '../../../hooks/useCafe24Auth';
import ShopModeContext from '../../../contexts/ShopModeContext';
import GuideModal from '../../../components/GuideModal';
import guideIcon from '../../../icons/ic-qmark-orange.png';
import LoadingAnimation from '../../../components/LoadingAnimation.js';

function ContentsPostingManagement({ history }) {
  const { auth: token } = useContext(AuthContext);
  const [makeShopURL, setMakeShopShopURL] = useState('');
  const mallId = localStorage.getItem('mallId');
  const { accessToken } = useCafe24Auth();
  const { shopMode } = useContext(ShopModeContext);
  const [isHovered, setIsHovered] = useState(false);

  const [isScriptGuideHovered, setIsScriptGuideHovered] = useState(false);

  const shopNo = Number(localStorage.getItem('shopNo'));
  const userNo = sessionStorage.getItem('userNo');
  const reqParams = useMemo(() => {
    return {
      token: accessToken,
      mallId,
      shopNo,
    };
  }, [mallId, shopNo, accessToken]);

  const axios = require('axios');
  const cheerio = require('cheerio');
  const [isOn, setIsOn] = useState(false); // 플러그인 설정 여부 (set or delete scripttag )
  const [isMobileOn, setIsMobileOn] = useState(false); // 플러그인 설정 여부 (set or delete scripttag ) - 모바일
  const [appliedDesign, setAppliedDesign] = useState([]); // 스크립트 적용된 디자인
  const [design, setDesign] = useState(''); // 대표 디자인

  const [appliedMobileDesign, setAppliedMobileDesign] = useState([]); // 스크립트 적용된 디자인 - 모바일
  const [mobileDesign, setMobileDesign] = useState(''); // 대표 디자인 - 모바일

  const [contentsList, setContentsList] = useState([]);

  const [publishedPCContents, setPublishedPCContents] = useState([]); // 퍼블리싱된 컨텐츠 리스트
  const [publishedMobileContents, setPublishedMobileContents] = useState([]);
  const [useMobileShop, setUseMobileShop] = useState(false);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false); // 적용된 디자인 안내 popover
  const popoverRef = useRef();

  const [isPluginCheckFinished, setIsPluginCheckFinished] = useState(false);
  const [isPluginFound, setIsPluginFound] = useState(false);

  useEffect(() => {
    getContentsList(
      {},
      (result) => {
        setContentsList(result);
        console.log('shopMode : ', shopMode);
        getPCPublishedContentList(
          {
            userNo,
            shop: shopMode,
            flag: true
          },
          (v) => {
            const contentsList = v.contentsList
              .map((content) => {
                const contentsDetail = result.find(
                  (item) => item.contentsNo === content.contentsNo
                );
                return {
                  ...content,
                  itemCount: contentsDetail?.itemCount || 0,
                  createDate: contentsDetail?.createDate || content.updateDate,
                };
              });
            console.log(contentsList, 'pc');
            setPublishedPCContents(contentsList);
          },
          () => { },
          (e) => {
            console.log('getPCPublishedContentList error');
          },
          token
        );

        getMobilePublishedContentList(
          {
            userNo,
            shop: shopMode,
            flag: true
          },
          (v) => {
            const contentsList = v.contentsList
              .map((content) => {
                const contentsDetail = result.find(
                  (item) => item.contentsNo === content.contentsNo
                );
                return {
                  ...content,
                  itemCount: contentsDetail?.itemCount || 0,
                  createDate: contentsDetail?.createDate || content.updateDate,
                };
              });
            console.log(contentsList, 'mobile');
            setPublishedMobileContents(contentsList);
          },
          () => { },
          (e) => {
            console.log('getPCPublishedContentList error');
          },
          token
        );
      },
      () => { },
      (e) => {
        console.log('getContentsList error');
      },
      token
    );
  }, [isOn, isMobileOn, shopMode]);

  useEffect(() => {
    if (accessToken) {
      getMobileShopEnabled(
        reqParams,
        (v) => {
          setUseMobileShop(v);
        },
        (e) => {
          console.log('getMobileShopEnabled error');
        },
        token
      );

      getShopSkin(
        reqParams,
        (data) => {
          setIsOn(data.isOn);
          setDesign(data.skin_name);
          setAppliedDesign(data.appliedDesign);
        },
        () => { },
        (e) => {
          console.log(e);
        },
        token
      );

      getMobileShopSkin(
        reqParams,
        (data) => {
          setIsMobileOn(data.isOn);
          setMobileDesign(data.skin_name);
          setAppliedMobileDesign(data.appliedDesign);
        },
        () => { },
        (e) => {
          console.log(e);
        },
        token
      );
    }
  }, [accessToken, token, reqParams]);

  useEffect(() => {
    const clickOutside = (e) => {
      if (isPopoverOpen && !popoverRef.current.contains(e.target)) {
        setIsPopoverOpen(false);
      }
    };
    document.addEventListener('mousedown', clickOutside);

    return () => {
      document.removeEventListener('mousedown', clickOutside);
    };
  }, [isPopoverOpen]);

  useEffect(() => {
    findMakeShopScript();
  }, [shopMode]);

  const findMakeShopScript = async () => {
    if (shopMode === 'makeshop') {
      console.log('findMakeShopScript');
      return new Promise((resolve, reject) => {
        getUserDetail(
          null,
          async (v) => {
            console.log(v.user.makeshopURL);
            if (!isPluginCheckFinished) {
              if (v.user.makeshopURL) {
                setMakeShopShopURL(v.user.makeshopURL);

                try {
                  await checkPlugins(
                    {
                      shopURL: v.user.makeshopURL,
                    },
                    (result) => {
                      console.log(result?.data);
                    //if (!result.isScriptFound) {

                      // if (!result?.data?.isScriptFound) {
                      if (!result?.data?.isScriptFound) {
                        resolve(false);
                        alert('메이크샵 쇼핑몰에서 외부 스크립트 연동이 필요합니다. \n\n아래 가이드를 참고하여 외부 스크립트를 연동해주세요.');
                        //window.location.replace('/mypage/shop-link');
                      } else {
                        resolve(true);
                        setIsPluginFound(true);
                      }
                    },
                    setIsPluginCheckFinished,
                    (e) => {
                      console.log('checkplugin error : ', e);
                    },
                    token
                  );

                  //return true;
                } catch (error) {
                  console.log('error', error);
                  reject(error);
                }
              } else {
                resolve(false);
                alert('메이크샵 연동을 먼저 진행해 주세요.');
                //alert('메이크샵 연동을 먼저 진행해 주세요.');
                //window.history.pushState("", "", '/mypage/shop-link');
                window.location.replace('/mypage/shop-link');
              }
            }
          },
          () => { },
          (e) => {
            console.log('getuserdetail', e);
            reject(e);
          },
          token
        );
      });
    } else {
      console.log('cafe24');
      return false;
    }
  };

  const clickToggle = (isMobile) => {
    if (!isMobile) {
      if (!isOn) {
        setShopScript(
          reqParams,
          (data) => {
            setAppliedDesign(data.skin_name);
          },
          () => { },
          (e) => {
            console.log(e);
          },
          token
        );
      } else {
        deleteShopScript(
          reqParams,
          () => { },
          () => { },
          (e) => {
            console.log(e);
          },
          token
        );
      }
      setIsOn(!isOn);
    } else {
      if (!isMobileOn) {
        setMobileShopScript(
          reqParams,
          (data) => {
            setAppliedMobileDesign(data.skin_name);
          },
          () => { },
          (e) => {
            console.log(e);
          },
          token
        );
      } else {
        deleteMobileShopScript(
          reqParams,
          () => { },
          () => { },
          (e) => {
            console.log(e);
          },
          token
        );
      }
      setIsMobileOn(!isMobileOn);
    }
  };

  const version = [
    {
      type: 'pc',
      name: 'PC',
      on: isOn,
      publishedContentsLength: publishedPCContents.length,
    },
    {
      type: 'mobile',
      name: '모바일',
      on: isMobileOn,
      publishedContentsLength: publishedMobileContents.length,
    },
  ];

  const renderPluginSetting = () => {
    return version.map((item) => (
      <ListItem key={item.type}>
        <PluginContainer>
          <PluginHeader>
            <Row>
              <img
                src={item.type === 'pc' ? icPc : icMobile}
                style={{
                  width: '24px',
                  height: '24px',
                }}
              />
              <Text size="24" color="white">
                {item.name}
              </Text>
            </Row>

            <Row gap={8} justify="flex-end">
              <ToggleBtn
                onClick={() => {
                  clickToggle(item.type === 'mobile');
                }}
                toggle={item.on}
              >
                <ToggleCircle toggle={item.on}></ToggleCircle>
              </ToggleBtn>
              <p style={{ color: item.on ? '#FFB600' : '#AAA' }}>
                {item.on ? 'ON' : 'OFF'}
              </p>
            </Row>
          </PluginHeader>
          <Col padding="14px 14px 20">
            <Text size="20" color="#4c4c4c" lineHeight="27px">
              {item.on ? '플러그인 적용된 디자인' : '대표 디자인'}
            </Text>

            <Row gap={3}>
              <Text color="#b5b5b5" size="16" weight="400" lineHeight="22px">
                {item.on
                  ? item.type === 'mobile'
                    ? appliedMobileDesign
                    : appliedDesign
                  : item.type === 'mobile'
                    ? mobileDesign
                    : design}
              </Text>

              {!(item.type === 'mobile'
                ? mobileDesign &&
                isMobileOn &&
                appliedMobileDesign.toString() !== mobileDesign.toString()
                : design &&
                isOn &&
                appliedDesign.toString() !== design.toString()) && (
                  <Text
                    borderRadius="10"
                    background="rgba(255, 122, 0, 0.3)"
                    color="#FF7A00"
                    size="13"
                    lineHeight="18px"
                    padding="0px 6px"
                    weight="400"
                  >
                    대표
                  </Text>
                )}
            </Row>
            {(item.type === 'mobile'
              ? mobileDesign &&
              isMobileOn &&
              appliedMobileDesign.toString() !== mobileDesign.toString()
              : design &&
              isOn &&
              appliedDesign.toString() !== design.toString()) && (
                <NotificationContainer>
                  <Row>
                    <InfoIcon>
                      <IcInfo stroke="#FF7A00" />
                    </InfoIcon>
                    <Text
                      size="14"
                      color="#FF7A00"
                      weight="400"
                      lineHeight="18px"
                      align="left"
                    >
                      현재 대표디자인과 플러그인이 적용된 디자인이
                      <br /> 다릅니다! 콘텐츠가 노출되지 않습니다.
                    </Text>
                  </Row>
                  <Col gap={8} padding="0">
                    <Text
                      size="16"
                      color="#4c4c4c"
                      weight="600"
                      lineHeight="22px"
                    >
                      대표 디자인
                    </Text>
                    <Col gap={4} padding="0">
                      <Text
                        color="#848484"
                        size="14"
                        weight="400"
                        lineHeight="19px"
                      >
                        {item.type === 'mobile'
                          ? `${mobileDesign} (대표)`
                          : `${design} (대표)`}
                      </Text>
                      <Text
                        style={{ textDecoration: 'underline' }}
                        color="#FF7A00"
                        size="12"
                        weight="400"
                        lineHeight="16px"
                      >
                        대표 디자인에 적용
                      </Text>
                    </Col>
                  </Col>
                </NotificationContainer>
              )}
          </Col>
          {/* {(item.publishedContentsLength === 0 || !item.on) && (
            <LoadingAnimation />
          )} */}
          {!(item.publishedContentsLength === 0 || !item.on) && (
            <>
              <DeviderContainer>
                <Devider />
              </DeviderContainer>

              <Col>
                <Row justify="space-between">
                  <Text size="20" color="#4c4c4c" lineHeight="27px">
                    배치된 콘텐츠
                  </Text>
                  <Button
                    $isActive
                    to={{
                      pathname: '/mypage/posted-contents-management',
                      state: {
                        shopVersion: item.type === 'mobile' ? 'mobile' : 'pc',
                      },
                    }}
                  >
                    <ButtonText>관리하기</ButtonText>
                    <NextIconContainer>
                      <NextIcon stroke="white" />
                    </NextIconContainer>
                  </Button>
                </Row>

                <Text color="#b5b5b5" size="16" weight="400" lineHeight="22px">
                  {item.type === 'mobile'
                    ? `${publishedMobileContents.length}개`
                    : `${publishedPCContents.length}개`}
                </Text>
              </Col>
            </>
          )}
        </PluginContainer>
      </ListItem>
    ));
  };

  return (
    <div style={{ position: 'relative' }}>
      <Title title="위즈몬 플러그인 관리" />
      {shopMode === 'cafe24' ? (
        <>
          <Container style={{ marginTop: 34 }}>
            <SubTitle>플러그인 설정</SubTitle>
            <Section>{renderPluginSetting()}</Section>
          </Container>
        </>
      ) : (
        <Container style={{ marginTop: 34 }}>
          
          <SubTitle color="#000">플러그인 설치 여부 <GuideButton
                shopMode={shopMode}
                onMouseEnter={() => setIsScriptGuideHovered(true)}
                onMouseLeave={() => setIsScriptGuideHovered(false)}
              >
                <img src={guideIcon} alt="가이드 보기 버튼" width={20} />
                  <GuideText isHovered={isScriptGuideHovered}>플러그인 설치 가이드</GuideText>
                  {isScriptGuideHovered && (
                    <GuideModal
                      style={{margin: '0 0 10px 100px'}}
                      videoLink=""
                      pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/%E1%84%86%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8F%E1%85%B3%E1%84%89%E1%85%A3%E1%86%B8_%E1%84%8B%E1%85%AC%E1%84%87%E1%85%AE+%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%B8%E1%84%90%E1%85%B3+%E1%84%8B%E1%85%A7%E1%86%AB%E1%84%83%E1%85%A9%E1%86%BC+%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf"
                    />
                  )}
          </GuideButton></SubTitle>
          

                
          <Row gap={9}>
            <Dot
              color={
                isPluginCheckFinished
                  ? isPluginFound
                    ? '#B0E441'
                    : '#FF0000'
                  : '#FFFF00'
              }
            />
            <Text size={22} color="#000" lineHeight="30px" weight="regular">
              {isPluginCheckFinished
                ? isPluginFound
                  ? '설치됨'
                  : '설치되지 않음'
                : '확인중...'}
            </Text>
          </Row>
          <div>
            {!isPluginCheckFinished && isPluginFound && (
              <>
                <div
                  style={{
                    display: 'inline-block',
                    padding: '10px',
                    background: '#F8F8F8',
                    marginTop: '15px',
                  }}
                >
                  <div
                    style={{
                      display: 'block',
                      color: '#848484',
                      fontSize: 14,
                    }}
                  >
                    플러그인 설치 가이드가 필요하신가요?
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div
                      onClick={() =>
                        window.open(
                          'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/wizmon-%E1%84%86%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8F%E1%85%B3%E1%84%89%E1%85%A3%E1%86%B8+%E1%84%80%E1%85%A6%E1%84%89%E1%85%B5%E1%84%86%E1%85%B5%E1%86%BC%E1%84%91%E1%85%B3%E1%86%AF%E1%84%85%E1%85%A5%E1%84%80%E1%85%B3%E1%84%8B%E1%85%B5%E1%86%AB%E1%84%80%E1%85%AA%E1%86%AB%E1%84%85%E1%85%B5+%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf',
                          '_blank'
                        )
                      }
                      style={{
                        display: 'flex',
                        color: '#FF7A00',
                        fontSize: 14,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      사용 가이드
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        color: '#848484',
                        fontSize: 14,
                      }}
                    >
                      를 통해 상세한 가이드와 안내문을 살펴보세요.
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Col padding="65px 0" gap={14}>
            <Text size="22" color="#000" lineHeight="26px" weight="regular">
              배치된 콘텐츠
            </Text>
            <Row width="242px" justify="space-between">
              <Row gap={15}>
                <DotOrange />
                <Text color="#000" size="22" weight={400} lineHeight="25px">
                  PC
                </Text>
              </Row>
              <Button
                $isActive={publishedPCContents.length !== 0}
                to={{
                  pathname: '/mypage/posted-contents-management',
                  state: {
                    shopVersion: 'pc',
                  },
                }}
                gap={10}
                padding="5.5px 2px 6px 20px"
                borderRadius={30}
                onClick={(e) => {
                  if (publishedPCContents.length === 0) {
                    e.preventDefault();
                  }
                }}
              >
                <ButtonText size="18" lineHeight="25" weight={500}>
                  {`총 ${publishedPCContents.length}개`}
                </ButtonText>
                <NextIconContainer width="24px" height="24px">
                  <NextIcon stroke="white" />
                </NextIconContainer>
              </Button>
            </Row>
            <Row width="242px" justify="space-between">
              <Row gap={15}>
                <DotOrange />
                <Text color="#000" size="22" weight={400} lineHeight="25px">
                  모바일
                </Text>
              </Row>
              <Button
                $isActive={publishedMobileContents.length !== 0}
                to={{
                  pathname: '/mypage/posted-contents-management',
                  state: {
                    shopVersion: 'mobile',
                  },
                }}
                gap={10}
                padding="5.5px 2px 6px 20px"
                borderRadius={30}
                onClick={(e) => {
                  if (publishedMobileContents.length === 0) {
                    e.preventDefault();
                  }
                }}
              >
                <ButtonText size="18" lineHeight="25" weight={500}>
                  {`총 ${publishedMobileContents.length}개`}
                </ButtonText>
                <NextIconContainer width="24px" height="24px">
                  <NextIcon stroke="white" />
                </NextIconContainer>
              </Button>
            </Row>
          </Col>
        </Container>
      )}
    </div>
  );
}

export default ContentsPostingManagement;

const NotificationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 5px;
  background-color: #fff0cc;
  padding: 10px 10px;
  gap: 20px;
`;

const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color || '#000'};
`;

const DotOrange = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 2px;
  background: #ffb600;
`;

const DeviderContainer = styled.div`
  width: 100%;
  padding: 0 14px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Devider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #b5b5b5;
`;

const ToggleBtn = styled.button`
  width: 75.5px;
  height: 36px;
  border-radius: 30px;
  border: none;
  background-color: #b5b5b5;
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  ${(props) => props.toggle && `background-color: #ffc840;`}
  box-shadow: inset 3px 2px 4px rgba(0, 0, 0, 0.25);
`;
const ToggleCircle = styled.div`
  position: absolute;
  left: 5px;
  width: 27px;
  height: 27px;
  background-color: #f4f4f4;
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
  box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.25);
  ${(props) => props.toggle && `transform: translateX(38px); `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

const SubTitle = styled.div`
  color: ${(props) => props.color || '#000'};
  font-size: 22px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const PluginContainer = styled.div`
  width: 382px;
  min-height: 274px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 5px;
  border: 1px solid #b5b5b5;
  background-color: white;
`;

const PluginHeader = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-radius: 5px 5px 0 0;
  background-color: #4d4d4d;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
`;

const Row = styled.div`
  width: ${(props) => props.width || 'auto'};
  display: flex;
  align-items: center;
  gap: ${(props) => props.gap || 10}px;
  justify-content: ${(props) => props.justify || 'flex-start'};
`;

const Col = styled.div`
  width: ${(props) => props.width || '100%'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(props) => props.padding || 14}px;
  gap: ${(props) => props.gap || 8}px;
  justify-content: ${(props) => props.justify || 'flex-start'};
`;

const Text = styled.div`
  display: flex;
  align-items: center;
  text-align: ${(props) => props.align || 'center'};
  font-size: ${(props) => props.size || 18}px;
  font-weight: ${(props) => props.weight || 600};
  color: ${(props) => props.color || '#000'};
  line-height: ${(props) => props.lineHeight || 0};
  border-radius: ${(props) => props.borderRadius || 0}px;
  padding: ${(props) => props.padding || '0'};
  background-color: ${(props) => props.background || 'transparent'};
`;

const Button = styled(Link)`
  gap: ${(props) => props.gap || 0}px;
  border: none;
  border-radius: ${(props) => props.borderRadius || 20}px;
  padding: ${(props) => props.padding || '5px 10px'};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.$isActive ? '#FFB600' : '#B5B5B5')};
`;

const NextIconContainer = styled.div`
  width: ${(props) => props.width || 18}px;
  height: ${(props) => props.height || 18}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonText = styled.span`
  text-align: center;
  font-size: ${(props) => props.size || 12}px;
  line-height: ${(props) => props.lineHeight || 16}px;
  color: #fff;
`;

const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  background-color: white;
  width: 36px;
  height: 36px;
`;

const GuideButton = styled.button`
  border: none;
  background-color: transparent;
  color: #ff7a00;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
  margin-left: 10px;
  cursor: pointer;
`;


const GuideText = styled.p`
  color: #ff7a00;
  font-size: 14px;
  cursor: pointer;
  text-decoration: ${(props) => (props.isHovered ? 'underline' : 'none')};
  line-height: ${(props) => (props.isHovered ? 'normal' : 'initial')};
  text-underline-position: under;
`;